import { watch } from 'vue';

const USCustomerKeys = ['taxId', 'zerohash_tnc'];
const CACustomerKeys = ['occupation'];

export default function useIdentityCountryMixin() {
  const triggerRequiredFieldSchemaChange = (store, keys, isRequired) => {
    keys.forEach((key) => store.updateRequiredFieldForKey(key, isRequired));
  };

  const updateFormVmodels = (form, keys, toDelete = false) => {
    const formShallow = form;
    if (toDelete) {
      keys.forEach((key) => delete formShallow.value[key]);
    } else {
      keys.forEach((key) => {
        if (key === 'zerohash_tnc') formShallow.value.zerohash_tnc = false;
        else formShallow.value[key] = '';
      });
    }
  };

  const watchCountryAndUpdateStoreHandler = (form, store, callback) => {
    watch(
      () => form.value.country,
      (newCountry, oldCountry) => {
        if (!newCountry) {
          return;
        }
        let USCustomerKeysFiltered = USCustomerKeys;
        if (store.getPersonalDetails.taxId === true) {
          USCustomerKeysFiltered = USCustomerKeys.filter((key) => key !== 'taxId');
        }

        const country = newCountry.toLowerCase();
        // reset; may need to revisit when adding other complex country requirements
          const allKeys = [...USCustomerKeys, ...CACustomerKeys];

        // remove all keys first
        triggerRequiredFieldSchemaChange(store, allKeys, false);
        updateFormVmodels(form, allKeys, true);

        setTimeout(() => {
          if (form.value.dob) {
            store.updateValue('dob', form.value.dob);
          }
        }, 500);

        switch (country) {
          case 'united states':
            triggerRequiredFieldSchemaChange(store, USCustomerKeysFiltered, true);
            updateFormVmodels(form, USCustomerKeysFiltered);
            break;
          case 'canada':
            triggerRequiredFieldSchemaChange(store, CACustomerKeys, true);
            updateFormVmodels(form, CACustomerKeys);
            break;
          default:
            break;
        }

        if (callback) {
          callback();
        }
      },
      { immediate: true },
    );
  };

  return {
    watchCountryAndUpdateStoreHandler,
  };
}
